<template>
  <div
    class="modal modal-flex fade"
    id="modal-add-consignment-note-to-stop"
    tabindex="-1"
    role="dialog"
    aria-labelledby="flexModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <validation-observer
        ref="validation"
        v-slot="{ validate }"
        tag="div"
        class="modal-content"
      >
          <div class="modal-header">
            <button
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
              class="close"
            >×</button>
            <h4 class="modal-title">Add Consignment Note</h4>
          </div>
          <!-- /.list-data -->
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <validation-provider
                  v-slot="{ errors, classes }"
                  name="note"
                  :rules="{ required: true }"
                  slim
                >
                  <div class="form-group" :class="classes" >
                    <div class="input-group">
                      <label class="control-label">Consignment Note</label>
                    </div>
                    <textarea
                      class="form-control-static"
                      style="width: 100%; resize: vertical;"
                      v-model="note"
                    >
                    </textarea>
                    <help-block v-bind="{ errors }" class="help-block"/>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <async-button
              type="button"
              class="btn btn-green"
              :click="handleSave"
              :validate="validate"
            >
              Save
            </async-button>
          </div>
        <!-- /.modal-content -->
        </validation-observer>
      </div>
    </div>
    <!-- /.modal-dialog -->
  <!-- /.modal -->
</template>

<script>
import BaseModal from 'components/BaseModal'
import { http } from 'utils'
import $ from 'jquery'

export default {
  extends: BaseModal,

  props: {
    runStop: {
      required: false,
      type: Object
    }
  },

  data () {
    return {
      deliveryRunId: null,
      note: null
    }
  },

  methods: {
    onModalShow () {
      this.deliveryRunId = this.$route.params.id
      this.note = this.runStop ? this.runStop.consignment_note : null
    },

    async handleSave () {
      await http.put(`/delivery-runs/${this.deliveryRunId}/stops/${this.runStop.id}/note`, {
        consignment_note: this.note
      })

      this.runStop.consignment_note = this.note

      $('#modal-add-consignment-note-to-stop').modal('toggle')
    }
  }
}
</script>
